import HTML from "./html.png"
import CSS from "./css.png"
import JavaScript from "./js.png"
import React from "./react.png"
import Java from "./java.png"
import MongoDB from "./mongo.png"
import RabbitMQ from "./rabbitmq.png"
import SpringBoot from "./spring-boot.png"
import Data_Algo from "./data-algo.png"
import MicroServices from "./microserviices.jpeg"

export const skillList = [
    {
        skillName: 'DS & Algorithm',
        skillUrl: Data_Algo,
    },
    {
        skillName: 'Java',
        skillUrl: Java,
    },
    {
        skillName: 'MongoDB',
        skillUrl: MongoDB,
    },
    {
        skillName: 'RabbitMQ',
        skillUrl: RabbitMQ,
    },
    {
        skillName: 'SpringBoot',
        skillUrl: SpringBoot,
    },
    {
        skillName: 'MicroServices',
        skillUrl: MicroServices,
    },
    {
        skillName: 'HTML',
        skillUrl: HTML,
    },
    {
        skillName: 'CSS',
        skillUrl: CSS,
    },
    {
        skillName: 'JavaScript',
        skillUrl: JavaScript,
    },
    {
        skillName: 'React',
        skillUrl: React
    }
];
